import React, { useContext, useEffect } from 'react';
import type { NextPage } from 'next';
import { PageLayout } from '@/components/pagelay';

import { useRouter } from 'next/router';

interface IProps {

}

const Default: NextPage<IProps> = ({ }) => {
  const router = useRouter()

  // useEffect(() => {
  //   router.push('/apply', '/apply', {
  //     shallow: true
  //   })
  // }, [])

  return (
    <PageLayout>
      <div style={{
        width: '50%',
        margin: 'auto',
        textAlign: 'center',
      }}>
        <img style={{ margin: '0 auto 60px' }} src="/image/continue.png" alt="" />
      </div>
    </PageLayout>
  )
};

export default Default;
